import { http, camelify } from '../rest';

export function fetch(http, camelify, demo) {
  return {
    async execute() {
      let data;
      if (demo) {
        const file = await import('./fetchAccount.data');
        data = file.default;
      } else {
        const response = await http.get('/advisor');
        data = response.data;
      }
      return camelify(data);
    },
  };
}

export default fetch(http, camelify, process.env.DEMO);
